import React from "react";
import PageHeader, { PageParagraph } from '../../components/Headers/Pageheaders';
import HairService from './Hair/Hair';
import Enquire from '../Buttons/Enquire';
import './styles.css';

export default function Services() {
  const PageDescription = `Specialists in the modern boho bride and bridal hair styling with over 20 years experience`
  return (
    <>
      <section>
        <PageHeader title="Pricing"/>      
        <PageParagraph text={PageDescription} endIcon={<Enquire isFilled={true} />} />
        <div className="container-fluid">
          <div className="service-grid justify-content-center">
            <HairService />
          </div>
        </div>
        <div style={{ marginBottom: '30px' }} />
      </section>      
    </>
  );
}
